import { CompassIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { Permission, Timeslot } from "types";
import { DashboardGuideResource, DisplayType } from "./DashboardGuideResource";
import { IsGranted } from "@/components/Common/IsGranted";

interface GuideDisplayProps {
    timeslot: Timeslot;
    displayType?: DisplayType;
    className?: string;
}

export const GuideDisplay = ({ timeslot, displayType = DisplayType.FULL, className }: GuideDisplayProps) => {
    return (
        <IsGranted permissions={Permission.DASHBOARD_VIEW}>
            <DashboardGuideResource
                icon={<CompassIcon />}
                timeslot={timeslot}
                displayType={displayType}
                className={clsx("ui-dashboard-guides", className)}
            />
        </IsGranted>
    );
};
